import { buttonStyle } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';

import { FormattedMessage } from 'react-intl';
import { PartyType } from 'types/contacts';
import { t } from 'utils/getTranslations';
import { ModalHeader } from '../ModalHeader';

type Props = {
    onCancel: () => void;
    onSelect: (value: PartyType) => void;
};

export const ContactTypePicker = ({ onCancel, onSelect }: Props): JSX.Element => (
    <>
        <ModalHeader title={t('contacts.choose-type')} onCancel={onCancel} />
        <div className="flex justify-center overflow-y-auto p-6 max-sm:px-4">
            <div className="flex flex-row gap-6 py-3">
                <Button
                    {...buttonStyle({ color: 'primary', variant: 'outlined', size: 'small' })}
                    onClick={() => onSelect(PartyType.PERSON)}
                >
                    <FormattedMessage id="contacts.types.person" />
                </Button>
                <Button
                    {...buttonStyle({ color: 'primary', variant: 'outlined', size: 'small' })}
                    onClick={() => onSelect(PartyType.COMPANY)}
                >
                    <FormattedMessage id="contacts.types.company" />
                </Button>
            </div>
        </div>
    </>
);
